<template>
  <div class="aarrow_box mt-5">
    <v-card-text>
      <span>
        <h5 class="accent--text" style="font-size: 12px; font-weight: 700">
          Paid and Pending Payments Report
        </h5>
        <!-- <div>
      <label for="pageSize">Items per Page:</label>
      <select v-model="itemsPerPage" @change="changePageSize" class="text-red">
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="20">20</option>

      </select>
    </div> -->
      </span>
      <table class="table table-responsive">
        <thead class="thead">
          <tr>
            <th scope="col">SEASON</th>
            <th scope="col">SALE</th>
            <th scope="col">E-SLIP</th>
            <th scope="col">STATUS</th>
            <th scope="col">AMOUNT</th>
            <th scope="col">WEIGHT</th>
            <th scope="col">ORG_NAME</th>
            <th scope="col">USER NAME</th>
            <th scope="col">PHONE</th>
            <th scope="col">EMAIL</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in paginatedData" :key="row.id">
            <td>{{ row.season }}</td>
            <td>{{ row.saleNumber }}</td>
            <td>{{ row.eslipNumber }}</td>
            <td>{{ row.status.statusName }}</td>
            <td>{{ row.eslipAmount }}</td>
            <td>{{ row.eslipWeight }}</td>
            <td>{{ row.organizationName }}</td>
            <td>{{ row.username }}</td>
            <td>{{ row.phonenumber }}</td>
            <td>{{ row.outgoingEmain }}</td>
            <td class="actions"></td>
          </tr>
        </tbody>
      </table>
    </v-card-text>
    <div>
      <v-btn @click="prevPage" :disabled="currentPage === 1" > {{ prev }}  Previous</v-btn>
      <span class="ml-2">Page {{ currentPage }} of {{ totalPages }}</span>
      <v-btn @click="nextPage" :disabled="currentPage === totalPages"><span class="ml-2">Next </span> {{ next }}</v-btn>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import config from "../../../config"

export default {
  name: 'PaidUnpaidData',
  data: function () {
    return {
      items: [],
      paginatedFiles: [],
      numberOfLinks: 0,
      page: 1,
      prev:'<<',
      next:'>>',
      payments: [],
      currentPage: 1,
      itemsPerPage: 7,
      //totalData: 100,
      totalItems: 1,
    }
  },

  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    paginatedData() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.payments.slice(startIndex, endIndex);
    },
  },

  mounted() {

    this.getPaymentsDetails(this.segmentSelected)

  },
  props: {
    segmentSelected: {
      type: String, // Adjust the type based on the actual type of the value you want to pass
      default: null,
    },
  },
  methods: {
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    changePageSize() {
      this.currentPage = 1; // Reset to the first page when changing page size
      this.loadData();
    },
    getPaymentsDetails(event) {
      console.log('event:  ====>'+event)  //PAID   PENDING  FAILED

      if ((event === "PAID") && (event !== "PENDING") && (event !== "FAILED")) {
        let id = 24
        const token = localStorage.getItem("token");
        const tokenconfig = { headers: { Authorization: `Bearer ${token}` } };
        const url = config.serverURI + "/reports/findAllPaymentsByStatus";
        axios
          .post(url, { id, tokenconfig })
          .then((response) => {
            this.payments = response.data;
            let arr = response.data
            this.totalItems = parseInt(Object.keys(response.data).length)
            this.payments = arr
            console.log('arr:  ====>'+arr)
            return arr
          })
          .catch((error) => {
            // Request failed.
            console.log("error", error.response);
            this.message = error.response.status;
            this.snackbar = true;
            this.snackbarColor = "error";
          });
        }
//       } else if ((event === "PAID") && (event !== "PENDING") && (event !== "FAILED")) {
//         let id = 9
//         const token = localStorage.getItem("token");
//         const tokenconfig = { headers: { Authorization: `Bearer ${token}` } };
//         const url = config.serverURI + "/reports/findAllPaymentsByStatus";
//         axios
//           .post(url, { id, tokenconfig })
//           .then((response) => {
//             this.payments = response.data;
//             let arr = response.data
//             this.totalItems = parseInt(Object.keys(response.data).length)
//             this.payments = arr
//             return arr
//           })
//           .catch((error) => {
//             // Request failed.
//             console.log("error", error.response);
//             this.message = error.response.status;
//             this.snackbar = true;
//             this.snackbarColor = "error";
//           });
//
//       } else  if ((event === "PAID") && (event !== "PENDING") && (event !== "FAILED")) {
//         let id = 24
//         const token = localStorage.getItem("token");
//         const tokenconfig = { headers: { Authorization: `Bearer ${token}` } };
//         const url = config.serverURI + "/reports/findAllPaymentsByStatus";
//         axios
//           .post(url, { id, tokenconfig })
//           .then((response) => {
//             this.payments = response.data;
//             let arr = response.data
//             this.totalItems = parseInt(Object.keys(response.data).length)
//             this.payments = arr
//             return arr
//           })
//           .catch((error) => {
//             // Request failed.
//             console.log("error", error.response);
//             this.message = error.response.status;
//             this.snackbar = true;
//             this.snackbarColor = "error";
//           });
//
//       }
      else if ((event !== "PAID") && (event !== "PENDING") && (event === "FAILED")) {
        const token = localStorage.getItem("token");
        const tokenconfig = { headers: { Authorization: `Bearer ${token}` } };
        let id = 26
        const url = config.serverURI + "/reports/findAllPaymentsByStatus";
        axios
          .post(url, {id, tokenconfig })
          .then((response) => {
            this.payments = response.data;
            let arr = response.data
            this.totalItems = parseInt(Object.keys(response.data).length)
            this.payments = arr
            return arr
          })
          .catch((error) => {
            // Request failed.
            console.log("error", error.response);
            this.message = error.response.status;
            this.snackbar = true;
            this.snackbarColor = "error";
          });

      } else if ((event !== "PAID") && (event === "PENDING") && (event !== "FAILED")) {
        const token = localStorage.getItem("token");
        const tokenconfig = { headers: { Authorization: `Bearer ${token}` } };
        let id = 5
        const url = config.serverURI + "/reports/findAllPaymentsByStatus";
        axios
          .post(url, { id,tokenconfig })
          .then((response) => {
            this.payments = response.data;
            let arr = response.data
            this.totalItems = parseInt(Object.keys(response.data).length)
            this.payments = arr
            return arr
          })
          .catch((error) => {
            // Request failed.
            console.log("error", error.response);
            this.message = error.response.status;
            this.snackbar = true;
            this.snackbarColor = "error";
          });

      }
    },

    getPaidUnpaidDetails() {
      const token = localStorage.getItem("token");
      const tokenconfig = { headers: { Authorization: `Bearer ${token}` } };
      //const withDet = config.serverURI + "/reports/findAllGrowersWithSettlementDetails";
      const allPayments = config.serverURI + "/reports/findAllPayments";
      // const withoutDet =
      //   config.serverURI + "/reports/findAllGrowersWithoutSettlementDetails";
      // const pendingApprov = config.serverURI + '/reports/findAllGrowersWithSettlementDetailsByStatus'

      const withSettlementDetails = axios.get(allPayments, { tokenconfig });
      //const withoutSettlementDetails = axios.post(withoutDet, { tokenconfig });
      // const pendingApproval =  axios.post (pendingApprov, { tokenconfig });

      axios
        .all([withSettlementDetails /*pendingApproval*/])
        .then(
          axios.spread((...responses) => {
            const responsewithDet = responses[0];
            const responsewithoutDet = responses[1];
            //const responespendingApprov = responses[2]

            let arr = responsewithDet.data

            this.totalItems = parseInt(Object.keys(responsewithDet.data).length)
            this.payments = arr
            //console.log("TEST..." + this.totalItems)
            return arr
          })
        )
        .catch((errors) => {
          console.log(errors);
        });
    },
  }
}
</script>
<style>
.custom-button {
  font-size: 16px;
  /* Add any additional styles for the button */
}
.aarrow_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
  border-radius: 5px;
}

.aarrow_box:after,
.aarrow_box:before {
  bottom: 100%;
  left: 60%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.aarrow_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #fff;
  border-width: 20px;
  margin-left: -20px;
}

.aarrow_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-bottom-color: #707070;
  border-width: 21px;
  margin-left: -21px;
}</style>
